import { Button, ButtonProps } from '@chakra-ui/react';
import React, { useState } from 'react';

type Props = ButtonProps;
function CustomButton(props: Props, ref: any) {
  const [loading, setLoading] = useState(false);

  async function handleClick(e: any) {
    try {
      setLoading(true);
      await props.onClick?.(e);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Button
      {...(props as any)}
      ref={ref}
      onClick={handleClick}
      isLoading={loading || props.isLoading}
    />
  );
}

export default React.forwardRef(CustomButton);
